export const HOLIDAYS_DELETE = id => `/holidays/${id}/`;
export const HOLIDAYS = '/holidays/';
